// removed by extract-text-webpack-plugin
module.exports = {"taskRecurrencyBlock":"TaskRecurrencyBlock__taskRecurrencyBlock__1E5iI","recurrencyType":"TaskRecurrencyBlock__recurrencyType__3RvfJ","typeIcon":"TaskRecurrencyBlock__typeIcon__2vOa-"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateBlockView/TaskTemplateBlockCard/TaskRecurrencyBlock/TaskRecurrencyBlock.scss
// module id = 1868
// module chunks = 0